// extracted by css-extract-rspack-plugin
export default {"Text":"ChecksStatusBadgeHeader-module__Text__kmP5P","Text_1":"ChecksStatusBadgeHeader-module__Text_1__tqD_9","Text_2":"ChecksStatusBadgeHeader-module__Text_2__G5IPl"};